import { getReduxType } from "../../utils/Actions";

export const setLanguage = (language: string) => ({
    type: getReduxType('set', 'language', language),
    data: language
});